import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppraisalService } from '../services/appraisal.service';

@Component({
  selector: 'app-number-assessment-l2',
  templateUrl: './number-assessment-l2.component.html',
  styleUrls: ['./number-assessment-l2.component.css']
})
export class NumberAssessmentL2Component implements OnInit {

  clickStatus = false;
  alreadySubmit = false;
   form_id;
  total_grade;
  alreadyDraft = false;
 
   formData =
  {
    'form_id':''
  };
  userData = {
    form_id : '',
    employee_code: '',
    employee_name : '',
    appraisal_period : '',
    form_type:'',
    employee_qualification : '',
    employee_designation : '',
    employee_department : '',
    employee_division : '',
    employee_grade : '',
    employee_DOB : '',
    employee_DOA : '',
    employee_LPM : '',
    l2_employee_code: '',
    l2_employee_name : '',
    l2_employee_designation : '',
    l2_employee_tasks : '',
    l2_employee_achievement : '',
    l2_performance_review : '',
    l2_performance_rating : '',
    l2_professional_knowledge : '',
    l2_technical_knowledge : '',
    l2_application_knowledge : '',
    l2_aptitudes : '',
    l2_competence : '',
    l2_job_knowledge_rating : '',
    l2_expression : '',
    l2_interaction : '',
    l2_judgement : '',
    l2_self_control : '',
    l2_leadership : '',
    l2_assertiveness : '',
    l2_flexibility : '',
    l2_personality_other : '',
    l2_personality_rating : '',
    l2_planning_skill : '',
    l2_organising_skill : '',
    l2_coordinating_skill : '',
    l2_controlling_skill : '',
    l2_problem_solving_skill : '',
    l2_decision_making_skill : '',
    l2_managerial_other : '',
    l2_managerial_rating : '',
    l2_man_management : '',
    l2_sub_ordinate_management : '',
    l2_delegation : '',
    l2_team_relationship : '',
    l2_proactiveness : '',
    l2_hr_management_other : '',
    l2_nsu_cooperation: '',
    l2_hr_management_rating : '',
    l2_idea_generation : '',
    l2_idea_implementation : '',
    l2_idea_innovative_approach : '',
    l2_system_development : '',
    l2_ideas_other : '',
    l2_ideas_innovation_rating : '',
    l2_dependability : '',
    l2_integrity : '',
    l2_attitude_work : '',
    l2_attitude_quality : '',
    l2_attitude_cost : '',
    l2_attitude_company : '',
    l2_commitment : '',
    l2_motivation : '',
    l2_inititative : '',
    l2_attitude_other : '',
    l2_attitude_rating : '',
    l2_potential : '',
    l2_potential_rating : '',
    l2_strong_points : '',
    l2_weak_points : '',
    l2_strong_weak_suggestion : '',
    l2_needed_training : '',
    l2_training_present_job : '',
    l2_training_future_job : '',
    l2_development_job_rotation : '',
    l2_development_job_enrichment : '',
    l2_development_other : '',
    l2_grading : 0,
    l2_grading_remarks : '',
    l2_is_appraisal_submit : '',
    l2_is_appraisal_date : ''


  }

  constructor( private apprais : AppraisalService, private router: Router, private route : ActivatedRoute ) { }

  ngOnInit() {
    
    this.form_id = this.route.snapshot.params.form_id;
     //console.log(this.form_id);
     this.formData.form_id = this.form_id;
    var user = this.apprais.getFormInfo(this.formData).subscribe(res=>{
        //console.log(res);
        this.userData.form_id = res.form_info.id;
        this.userData.employee_code = res.form_info.employee_code_app;
        this.userData.employee_name = res.form_info.employee_name_app;
        this.userData.appraisal_period = res.form_info.appraisal_period;
        this.userData.form_type = res.form_info.form_type;
        this.userData.employee_qualification = res.form_info.employee_qualification;
        this.userData.employee_designation = res.form_info.employee_designation;
        this.userData.employee_department = res.form_info.employee_department;
        this.userData.employee_division = res.form_info.employee_division;
        this.userData.employee_grade = res.form_info.employee_grade;
        this.userData.employee_DOB = this.dateFun(res.form_info.employee_DOB);
        this.userData.employee_DOA = this.dateFun(res.form_info.employee_DOA);
        this.userData.employee_LPM = this.dateFun(res.form_info.employee_LPM);
        this.userData.l2_employee_code = res.form_info.l2_employee_code;
        this.userData.l2_employee_name = res.form_info.l2_employee_name;
        this.userData.l2_employee_designation = res.form_info.l2_employee_designation;
        this.userData.l2_employee_tasks = res.form_info.l2_employee_tasks;
        this.userData.l2_employee_achievement = res.form_info.l2_employee_achievement;
        this.userData.l2_performance_review = res.form_info.l2_performance_review;
        this.userData.l2_performance_rating = res.form_info.l2_performance_rating;
        this.userData.l2_professional_knowledge = res.form_info.l2_professional_knowledge;
        this.userData.l2_technical_knowledge = res.form_info.l2_technical_knowledge;
        this.userData.l2_application_knowledge = res.form_info.l2_application_knowledge;
        this.userData.l2_aptitudes = res.form_info.l2_aptitudes;
        this.userData.l2_competence = res.form_info.l2_competence;
        this.userData.l2_job_knowledge_rating = res.form_info.l2_job_knowledge_rating;
        this.userData.l2_expression = res.form_info.l2_expression;
        this.userData.l2_interaction = res.form_info.l2_interaction;
        this.userData.l2_judgement = res.form_info.l2_judgement;
        this.userData.l2_self_control = res.form_info.l2_self_control;
        this.userData.l2_leadership = res.form_info.l2_leadership;
        this.userData.l2_assertiveness = res.form_info.l2_assertiveness;
        this.userData.l2_flexibility = res.form_info.l2_flexibility;
        this.userData.l2_personality_other = res.form_info.l2_personality_other;
        this.userData.l2_personality_rating = res.form_info.l2_personality_rating;
        this.userData.l2_planning_skill = res.form_info.l2_planning_skill;
        this.userData.l2_organising_skill = res.form_info.l2_organising_skill;
        this.userData.l2_coordinating_skill = res.form_info.l2_coordinating_skill;
        this.userData.l2_controlling_skill = res.form_info.l2_controlling_skill;
        this.userData.l2_problem_solving_skill = res.form_info.l2_problem_solving_skill;
        this.userData.l2_decision_making_skill = res.form_info.l2_decision_making_skill;
        this.userData.l2_managerial_other = res.form_info.l2_managerial_other;
        this.userData.l2_managerial_rating = res.form_info.l2_managerial_rating;
        this.userData.l2_man_management = res.form_info.l2_man_management;
        this.userData.l2_sub_ordinate_management = res.form_info.l2_sub_ordinate_management;
        this.userData.l2_delegation = res.form_info.l2_delegation;
        this.userData.l2_team_relationship = res.form_info.l2_team_relationship;
        this.userData.l2_proactiveness = res.form_info.l2_proactiveness;
        this.userData.l2_hr_management_other = res.form_info.l2_hr_management_other;
        this.userData.l2_nsu_cooperation = res.form_info.l2_nsu_cooperation;
        this.userData.l2_hr_management_rating = res.form_info.l2_hr_management_rating;
        this.userData.l2_idea_generation = res.form_info.l2_idea_generation;
        this.userData.l2_idea_implementation = res.form_info.l2_idea_implementation;
        this.userData.l2_idea_innovative_approach = res.form_info.l2_idea_innovative_approach;
        this.userData.l2_system_development = res.form_info.l2_system_development;
        this.userData.l2_ideas_other = res.form_info.l2_ideas_other;
        this.userData.l2_ideas_innovation_rating = res.form_info.l2_ideas_innovation_rating;
        this.userData.l2_dependability = res.form_info.l2_dependability;
        this.userData.l2_integrity = res.form_info.l2_integrity;
        this.userData.l2_attitude_work = res.form_info.l2_attitude_work;
        this.userData.l2_attitude_quality = res.form_info.l2_attitude_quality;
        this.userData.l2_attitude_cost = res.form_info.l2_attitude_cost;
        this.userData.l2_attitude_company = res.form_info.l2_attitude_company;
        this.userData.l2_commitment = res.form_info.l2_commitment;
        this.userData.l2_motivation = res.form_info.l2_motivation;
        this.userData.l2_inititative = res.form_info.l2_inititative;
        this.userData.l2_attitude_other = res.form_info.l2_attitude_other;
        this.userData.l2_attitude_rating = res.form_info.l2_attitude_rating;
        this.userData.l2_potential = res.form_info.l2_potential;
        this.userData.l2_potential_rating = res.form_info.l2_potential_rating;
        this.userData.l2_strong_points = res.form_info.l2_strong_points;
        this.userData.l2_weak_points = res.form_info.l2_weak_points;
        this.userData.l2_strong_weak_suggestion = res.form_info.l2_strong_weak_suggestion;
        this.userData.l2_needed_training = res.form_info.l2_needed_training;
        this.userData.l2_training_present_job = res.form_info.l2_training_present_job;
        this.userData.l2_training_future_job = res.form_info.l2_training_future_job;
        this.userData.l2_development_job_rotation = res.form_info.l2_development_job_rotation;
        this.userData.l2_development_job_enrichment = res.form_info.l2_development_job_enrichment;
        this.userData.l2_development_other = res.form_info.l2_development_other;
        this.userData.l2_grading = res.form_info.l2_grading;
        this.userData.l2_grading_remarks = res.form_info.l2_grading_remarks;
        this.userData.l2_is_appraisal_date = res.form_info.l2_is_appraisal_date;
        this.userData.l2_is_appraisal_submit = res.form_info.l2_is_appraisal_submit;
    })
  }
  dateFun(dateStr)
  {
    var dateObj = new Date(dateStr);
    var month = dateObj.getMonth()+1; //months from 1-12
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    
    var newdate = year + "-" + month + "-" + day;
    //var newdate = day + "/" + month + "/" + year;
    //console.log(newdate);
    return newdate;
    
  }
  totalGrade()
  {
    //console.log(this.userData.l2_performance_rating);
      var l2_performance_rating = (typeof this.userData.l2_performance_rating === 'number')?this.userData.l2_performance_rating:0;
      var l2_job_knowledge_rating = (typeof this.userData.l2_job_knowledge_rating === 'number')?this.userData.l2_job_knowledge_rating:0;
      var l2_personality_rating = (typeof this.userData.l2_personality_rating === 'number')?this.userData.l2_personality_rating:0;
      var l2_managerial_rating = (typeof this.userData.l2_managerial_rating === 'number')?this.userData.l2_managerial_rating:0;
      var l2_hr_management_rating = (typeof this.userData.l2_hr_management_rating === 'number')?this.userData.l2_hr_management_rating:0;
      var l2_ideas_innovation_rating = (typeof this.userData.l2_ideas_innovation_rating === 'number')?this.userData.l2_ideas_innovation_rating:0;
      var l2_attitude_rating = (typeof this.userData.l2_attitude_rating === 'number')?this.userData.l2_attitude_rating:0;
      var l2_potential_rating = (typeof this.userData.l2_potential_rating === 'number')?this.userData.l2_potential_rating:0;
      
      this.total_grade =l2_performance_rating +l2_job_knowledge_rating+ l2_personality_rating + l2_managerial_rating + l2_hr_management_rating +l2_ideas_innovation_rating +l2_attitude_rating + l2_potential_rating ;
     
      this.userData.l2_grading = this.total_grade;
     // console.log(this.userData.l2_grading);

  }
  isValid(l2NumberForm,control) 
  {
   
    if((!l2NumberForm.controls[control].valid && (l2NumberForm.controls[control].dirty ||l2NumberForm.controls[control].touched)) || (!l2NumberForm.controls[control].valid && this.clickStatus))
    {
       //var errorStr = '<div class="alert alert-danger"> * ' + control+ ' is required</div>';
       var errorStr = '<div class="alert alert-danger"> * ' + 'This field is required</div>';
      return errorStr;
    }
  }
  onDraft(l2NumberForm)
  {

    this.alreadyDraft = true;
    this.userData.l2_grading_remarks =this.getGradeRemarks(this.userData.l2_grading);
    var selfData = this.apprais.setL2GradData(this.userData).subscribe( res => {
      if(this.userData.form_type == '1')
      {
        localStorage.setItem('appraisal_msg',res.message);
        this.router.navigate(['/selfAppraisalAssign']);
      }
      else{
        localStorage.setItem('nus_msg',res.message);
        this.router.navigate(['/nsuAssignL2']);
      }
     
     })

  }
  onSubmit(l2NumberForm)
  {
    /*console.log(this.userData);
    var selfData = this.apprais.setL2GradData(this.userData).subscribe( res => {
      localStorage.setItem('appraisal_msg',res.message);
     
     })*/
     this.userData.l2_grading_remarks =this.getGradeRemarks(this.userData.l2_grading);
    this.clickStatus = true;
    if(l2NumberForm.valid)
    {
     this.alreadySubmit = true;
     this.userData.l2_is_appraisal_submit = '1';

    var selfData = this.apprais.setL2GradData(this.userData).subscribe( res => {
      if(this.userData.form_type == '1')
      {
        localStorage.setItem('appraisal_msg',res.message);
        this.router.navigate(['/selfAppraisalAssign']);
      }
      else{
        localStorage.setItem('nus_msg',res.message);
        this.router.navigate(['/nsuAssignL2']);
      }
     })
    }
  }

  getGradeRemarks(val)
  {
    var remarks = '';
    var l2_grading = (typeof val === 'number')?val:0;
    if((l2_grading>90))
    {
      remarks = 'Outstanding';
    }
    else if((l2_grading>71) && (l2_grading<=90))
    {
      remarks = 'Very Good';
    }
    else if((l2_grading>55) && (l2_grading<=70))
    {
      remarks = 'Good';
    }
    else if((l2_grading>=40) && (l2_grading<=54))
    {
      remarks = 'Average';
    }
    else 
    {
      remarks = 'Unsatisfactory';
    }
    return remarks;

  }

  conFun(l2NumberForm)
  {
    var r = confirm("Is it the final submission?");
    if (r == true) {
      this.onSubmit(l2NumberForm);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/number-assessment-l2/number-assessment-l2.component.ts